import { iBookingDiscussionItem } from "@sdk/bookings/booking-discussion-item-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { bookingDiscussionItemsDefaultQueryConfig } from "./booking-discussion-items-default-query";

export const {
  slice: BookingDiscussionItemsSlice,
  reducers: BookingDiscussionItemsSliceReducer,
  actions: {
    setEntityQueryResults: setBookingDiscussionItemsQueryResults,
    setEntity: setBookingDiscussionItem,
    setEntities: setBookingDiscussionItems,
    patchEntity: patchBookingDiscussionItem,
    addNewEntity: addNewBookingDiscussionItem,
    setEntityFetchingStatus: setBookingDiscussionItemFetchingStatus,
    setEntitiesFetchingStatus: setBookingDiscussionItemsFetchingStatus,
    setEntityFailedStatus: setBookingDiscussionItemFailedStatus,
    setEntityQueryError: setBookingDiscussionItemsQueryError,
    resetQuery: resetBookingDiscussionItemsQuery,
    setQueryList: setBookingDiscussionItemQueryList,
  },
} = CreateEntitySlice<iBookingDiscussionItem>({
  sliceName: "bookingDiscussionItems",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...bookingDiscussionItemsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
